import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const HeadphonesFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M20.93 12.83c0-5.4-4-9.79-8.92-9.79S3.1 7.43 3.1 12.83v4.01c0 2.03 1.65 3.68 3.68 3.68 1.29 0 2.34-1.05 2.34-2.34V14.8c0-1.29-1.05-2.34-2.34-2.34-.7 0-1.35.21-1.9.55v-.18c0-4.42 3.21-8.02 7.15-8.02 3.94 0 7.15 3.6 7.15 8.02v.2c-.56-.35-1.22-.56-1.93-.56-1.29 0-2.34 1.05-2.34 2.34v3.38c0 1.29 1.05 2.34 2.34 2.34 2.03 0 3.68-1.65 3.68-3.68v-.46h.02v-3.55l-.02-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default HeadphonesFilled
